/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} VaultInputs */

const en_vault = /** @type {(inputs: VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault:`)
};

const es_vault = /** @type {(inputs: VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bóveda:`)
};

const fr_vault = /** @type {(inputs: VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coffre-fort :`)
};

const de_vault = /** @type {(inputs: VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault:`)
};

const ja_vault = /** @type {(inputs: VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保管庫:`)
};

const zh_vault = /** @type {(inputs: VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`金库：`)
};

const ar_vault = /** @type {(inputs: VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الخزنة:`)
};

const id_vault = /** @type {(inputs: VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault:`)
};

const it_vault = /** @type {(inputs: VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault:`)
};

const ru_vault = /** @type {(inputs: VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хранилище:`)
};

const pt_vault = /** @type {(inputs: VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cofre:`)
};

const ko_vault = /** @type {(inputs: VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보관소(Vault):`)
};

/**
* | output |
* | --- |
* | "Vault:" |
*
* @param {VaultInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const vault = /** @type {((inputs?: VaultInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<VaultInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vault(inputs)
	if (locale === "es") return es_vault(inputs)
	if (locale === "fr") return fr_vault(inputs)
	if (locale === "de") return de_vault(inputs)
	if (locale === "ja") return ja_vault(inputs)
	if (locale === "zh") return zh_vault(inputs)
	if (locale === "ar") return ar_vault(inputs)
	if (locale === "id") return id_vault(inputs)
	if (locale === "it") return it_vault(inputs)
	if (locale === "ru") return ru_vault(inputs)
	if (locale === "pt") return pt_vault(inputs)
	return ko_vault(inputs)
});